/**
 * テーマV2の共通処理
 */
(function () {
  "use strict";

  // 定数
  const BREAKPOINTS = {
    desktop: 1080,
    mobile: 769,
  };

  const SELECTORS = {
    searchInput: ".v2-search-input",
    searchClear: ".v2-search-clear-text-btn",
    headerSticky: ".js-v2-header-sticky",
    headerSpHam: ".js-v2-header-sp-ham",
    searchCt: ".js-search-ct",
    currentMiles: ".js-current-miles",
    mileSteps: ".js-mile-steps",
    mileBarGraph: ".js-mile-bar-graph",
    productCard: ".product-card-default",
  };

  const TRANSITION_DURATION = {
    imageSwitch: "0.2s",
    barGraph: "1s",
  };

  const SCROLL_UP_THRESHOLD = 50;
  const SWIPE_THRESHOLD = 50;
  const SWIPE_MOVE_THRESHOLD = 10;

  /** カラーバリエーション自動切り替えの間隔（ミリ秒） */
  const PRODUCT_IMAGE_AUTO_ROTATE_INTERVAL = 2000;

  /**
   * 検索入力のクリア機能
   */
  const initializeSearchLogic = () => {
    const searchInputs = document.querySelectorAll(SELECTORS.searchInput);
    const searchInputClears = document.querySelectorAll(SELECTORS.searchClear);

    if (searchInputs.length === 0) return;

    // URLパラメータから検索クエリを取得
    const urlParams = new URLSearchParams(window.location.search);
    const searchQuery = urlParams.get("q");

    if (searchQuery) {
      searchInputClears.forEach((clearBtn) => {
        clearBtn.classList.add("is-show");
      });
    }

    // クリアボタンの表示/非表示
    const displayClearButton = (e) => {
      const clearBtn = e.target.nextElementSibling;
      if (clearBtn) {
        clearBtn.classList.toggle("is-show", e.target.value !== "");
      }
    };

    const clearSearchText = (e) => {
      const clickedBtn = e.currentTarget;
      const parentForm = clickedBtn.closest('.v2-form-hd-search-inr');
      const relatedInput = parentForm ? parentForm.querySelector('.v2-search-input') : null;

      searchInputs.forEach((input) => {
        input.value = "";
      });
      searchInputClears.forEach((clearBtn) => {
        clearBtn.classList.remove("is-show");
      });

      if (relatedInput) {
        relatedInput.focus();
      }
    };

    searchInputs.forEach((input) => {
      input.addEventListener("input", displayClearButton);
    });

    searchInputClears.forEach((clearBtn) => {
      clearBtn.addEventListener("click", clearSearchText);
    });
  };

  /**
   * チャットプラグインの表示/非表示を切り替え
   */
  const toggleChPlugin = () => {
    const chPlugin = document.getElementById("ch-plugin");
    if (chPlugin) {
      chPlugin.classList.toggle("hide");
    }
  };

  /**
   * マイルの棒グラフを描画
   */
  const createBarGraph = (mileValue) => {
    const pointElements = document.querySelectorAll(SELECTORS.mileSteps);
    if (pointElements.length === 0) return;

    const points = Array.from(pointElements)
      .map((element) => {
        const text = element.textContent.replace(/,/g, "");
        return parseInt(text, 10);
      })
      .filter((value) => !Number.isNaN(value));

    if (points.length === 0) return;

    // 現在のマイル値がどの範囲にあるかを判定
    let lowerPoint = 0;
    let upperPoint = points[0];
    let index = 0;

    for (let i = 0; i < points.length; i++) {
      if (mileValue <= points[i]) {
        upperPoint = points[i];
        index = i;
        break;
      }
      lowerPoint = points[i];
    }

    // パーセンテージを計算
    const range = upperPoint - lowerPoint;
    const relativePosition = mileValue - lowerPoint;
    const pointsLength = points.length;
    let percentage = 0;

    if (mileValue > points[pointsLength - 1]) {
      percentage = 100;
    } else if (range === 0) {
      percentage = ((index + 1) / pointsLength) * 100;
    } else {
      percentage =
        (relativePosition / range / pointsLength + index / pointsLength) * 100;
    }

    // バーグラフを更新
    const barGraphs = document.querySelectorAll(SELECTORS.mileBarGraph);
    barGraphs.forEach((bar) => {
      const computedStyle = window.getComputedStyle(bar);
      if (!computedStyle.transition.includes("width")) {
        bar.style.transition = `width ${TRANSITION_DURATION.barGraph} ease`;
      }
      requestAnimationFrame(() => {
        bar.style.width = `${percentage}%`;
      });
    });
  };

  /**
   * ヘッダーの動作を初期化
   */
  const initializeHeaderBehavior = () => {
    const header = document.querySelector(SELECTORS.headerSticky);
    if (!header) return;

    let lastScrollTop = window.scrollY || 0;
    let scrollUpAccumulated = 0;
    let isHeaderVisible = true;

    const showHeader = () => {
      if (isHeaderVisible) return;
      isHeaderVisible = true;
      header.classList.add("is-show");
    };

    const hideHeader = () => {
      if (!isHeaderVisible) return;
      isHeaderVisible = false;
      scrollUpAccumulated = 0;
      header.classList.remove("is-show");
    };

    const handleScroll = () => {
      const currentScrollTop = window.scrollY || 0;

      if (currentScrollTop <= 0) {
        showHeader();
        lastScrollTop = 0;
        scrollUpAccumulated = 0;
        return;
      }

      const delta = lastScrollTop - currentScrollTop;

      if (delta > 0) {
        scrollUpAccumulated += delta;
        if (scrollUpAccumulated >= SCROLL_UP_THRESHOLD) {
          showHeader();
        }
      } else {
        scrollUpAccumulated = 0;
        hideHeader();
      }

      lastScrollTop = currentScrollTop;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    // メニューの開閉
    const toggleMenu = () => {
      header.classList.toggle("is-active");
      toggleChPlugin();
    };

    // 開閉は v2-header.liquid の直後のスクリプトがヘッダー描画時点で付けている（10/13 読み込み中のデッドクリック対策）。
    // 付いていないヘッダー（cafe-header 等）だけここで付ける
    if (header.dataset.menuBound) return;

    const spMenu = document.querySelector(SELECTORS.headerSpHam);
    const pcMenu = document.querySelector(SELECTORS.searchCt);

    if (spMenu) {
      // モバイル: touchendで即時反応（1回目タップ無反応を回避）
      let touchMoved = false;
      spMenu.addEventListener(
        "touchstart",
        () => {
          touchMoved = false;
        },
        { passive: true }
      );
      spMenu.addEventListener(
        "touchmove",
        () => {
          touchMoved = true;
        },
        { passive: true }
      );
      spMenu.addEventListener("touchend", (e) => {
        if (!touchMoved) {
          e.preventDefault();
          toggleMenu();
        }
      });
      // PC・マウス操作用
      spMenu.addEventListener("click", (e) => {
        if ("ontouchstart" in window) return; // タッチデバイスはtouchendで処理済み
        toggleMenu();
      });
    }
    if (pcMenu) {
      pcMenu.addEventListener("click", toggleMenu);
    }
  };

  /**
   * マイルグラフを初期化
   */
  const initializeMileGraph = () => {
    const currentMilesElement = document.querySelector(SELECTORS.currentMiles);
    if (!currentMilesElement) return;

    const numericValue = parseInt(
      currentMilesElement.textContent.replace(/,/g, ""),
      10,
    );

    if (Number.isNaN(numericValue)) return;

    createBarGraph(numericValue);
    currentMilesElement.textContent = numericValue.toLocaleString();
  };

  /**
   * カテゴリ一覧の開閉（SPのみ）
   */
  const categoryExpand = (target) => {
    if (window.innerWidth > BREAKPOINTS.desktop) return;

    const categories = document.querySelectorAll(`${target} .js-categories`);
    if (categories.length === 0) return;

    categories.forEach((category) => {
      // 既にイベントリスナーが設定されている場合はスキップ
      if (category.dataset.listenerAttached === "true") return;
      category.dataset.listenerAttached = "true";

      const clickHandler = (e) => {
        e.preventDefault();

        const parentDl = category.closest(`${target} dl.list`);
        if (!parentDl) return;

        const isActive = parentDl.classList.contains("is-show");

        // 他のリストを閉じる
        const allLists = document.querySelectorAll(`${target} dl.list.is-show`);
        allLists.forEach((list) => {
          list.classList.remove("is-show");
        });

        // クリックされたリストを開く/閉じる
        if (!isActive) {
          parentDl.classList.add("is-show");
        }
      };

      category.addEventListener("click", clickHandler);
    });
  };

  // 他のスクリプトから利用できるように公開
  window.themeV2 = window.themeV2 || {};
  window.themeV2.categoryExpand = categoryExpand;

  /**
   * Appifyアプリ判定
   */
  const addAppifyClass = () => {
    if (navigator.userAgent.includes("Appify")) {
      document.documentElement.classList.add("in-appify-app");
    }
  };

  /**
   * 商品カード画像のスワイプ機能を初期化
   */
  const setSwipeProductCardImage = () => {
    const productCards = document.querySelectorAll(SELECTORS.productCard);
    if (productCards.length === 0) return;

    productCards.forEach((card) => {
      if (card.dataset.sliderInitialized === "true") return;
      card.dataset.sliderInitialized = "true";

      const imagesData = card.dataset.productImages;
      if (!imagesData) return;

      const productImages = imagesData
        .split(",")
        .map((url) => url.trim())
        .filter((url) => url.length > 0);

      if (productImages.length < 2) return;

      const mainImage = card.querySelector(".product-card-default-thum-image");
      const mainImageLink = card.querySelector(
        ".product-card-default-thum-link",
      );
      const imageContainer = mainImage?.closest(".product-card-default-thum");
      // ホバー検知はカード全体で行う（画像エリアがリンク内で検知しづらい場合の対策）
      const hoverTarget = card;

      if (!mainImage || !mainImageLink || !imageContainer) return;

      // 画像の初期設定
      mainImage.style.opacity = "1";
      mainImage.style.transition = "";

      try {
        mainImage.decoding = "async";
        // 9/29: ここで eager にすると、非表示タブ・画面外のカードまで一斉に読み込まれるので lazy のまま（見えれば通常どおり読む）
      } catch (e) {
        // ブラウザが対応していない場合は無視
      }

      const initialIndex = parseInt(
        card.dataset.initialImageIndex || "0",
        10,
      );
      let currentIndex = Math.min(
        Math.max(0, initialIndex),
        productImages.length - 1,
      );
      const isDesktop = window.innerWidth > BREAKPOINTS.desktop;
      const preloadedImages = new Set();

      // 初期表示を currentIndex に合わせる
      if (currentIndex > 0) {
        mainImage.setAttribute("src", productImages[currentIndex]);
      }

      // 画像のプリロード（読み込み完了時のみ preloadedImages に追加＝初回切り替えの遅延防止）
      // 9/29: 読み込み直後に全カード分を先読みすると、非表示タブ・画面外のカードの画像まで一斉に落ちる。
      //       カードが画面に近づいた時（200px 手前）か、ホバーした時に 1 回だけ先読みする
      let preloadStarted = false;
      const preloadAll = () => {
        if (preloadStarted) return;
        preloadStarted = true;
        productImages.forEach((imgSrc, idx) => {
          if (preloadedImages.has(imgSrc)) return;
          const img = new Image();
          try {
            img.decoding = "async";
            img.fetchPriority = idx < 2 ? "high" : "low";
            img.loading = "eager";
          } catch (e) {
            // ブラウザが対応していない場合は無視
          }
          img.onload = () => preloadedImages.add(imgSrc);
          img.onerror = () => {};
          img.src = imgSrc;
        });
      };
      if ("IntersectionObserver" in window) {
        const preloadIo = new IntersectionObserver((entries) => {
          if (entries.some((en) => en.isIntersecting)) { preloadIo.disconnect(); preloadAll(); }
        }, { rootMargin: "200px" });
        preloadIo.observe(card);
      } else {
        preloadAll();
      }
      card.addEventListener("pointerenter", preloadAll, { once: true });

      // 画像切り替え関数
      const switchImage = (index) => {
        if (
          index < 0 ||
          index >= productImages.length ||
          index === currentIndex
        ) {
          return;
        }

        const newImageSrc = productImages[index];
        currentIndex = index;

        // ドットの更新
        const dots = card.querySelectorAll(".product-card-default-dot");
        dots.forEach((dot, i) => {
          dot.classList.toggle("is-active", i === index);
        });

        // product-card-default-item の active 更新（表示中画像と一致する最初の1枚のみ）
        const variantItems = card.querySelectorAll(
          ".product-card-default-item[data-variant-image-index]",
        );
        variantItems.forEach((el) => {
          el.classList.remove("is-active");
        });
        const activeItem = Array.from(variantItems).find(
          (el) => el.dataset.variantImageIndex === String(index),
        );
        if (activeItem) activeItem.classList.add("is-active");

        const isImageLoaded = preloadedImages.has(newImageSrc);

        const switchToNewImage = () => {
          mainImage.setAttribute("src", newImageSrc);
          requestAnimationFrame(() => {
            mainImage.style.transition = `opacity ${TRANSITION_DURATION.imageSwitch} ease-in`;
            mainImage.style.opacity = "1";
          });
        };

        const doSwitch = () => {
          if (isImageLoaded) {
            switchToNewImage();
          } else {
            const imgLoader = new Image();
            imgLoader.src = newImageSrc;

            if (imgLoader.complete && imgLoader.naturalWidth > 0) {
              preloadedImages.add(newImageSrc);
              switchToNewImage();
            } else {
              imgLoader.onload = () => {
                preloadedImages.add(newImageSrc);
                switchToNewImage();
              };
              imgLoader.onerror = () => {
                mainImage.style.opacity = "1";
                mainImage.style.transition = `opacity ${TRANSITION_DURATION.imageSwitch} ease-in-out`;
              };
            }
          }
        };

        // フェードアウト → transitionend で切り替え（+ 安全タイマー）
        let switched = false;
        const onceSwitch = () => {
          if (switched) return;
          switched = true;
          doSwitch();
        };

        mainImage.style.transition = `opacity ${TRANSITION_DURATION.imageSwitch} ease-out`;
        mainImage.style.opacity = "0";

        mainImage.addEventListener("transitionend", function handler(e) {
          if (e.propertyName !== "opacity" || e.target !== mainImage) return;
          mainImage.removeEventListener("transitionend", handler);
          onceSwitch();
        }, { once: true });

        // transitionend が発火しないケースの安全策
        setTimeout(onceSwitch, 300);
      };

      // カラーバリエーション自動アニメーション（hover/active時のみ、1枚ずつ）
      const prefersReducedMotion =
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      let autoRotateTimer = null;

      const startAutoRotate = () => {
        if (prefersReducedMotion || autoRotateTimer) return;
        autoRotateTimer = setInterval(() => {
          const nextIndex = (currentIndex + 1) % productImages.length;
          switchImage(nextIndex);
        }, PRODUCT_IMAGE_AUTO_ROTATE_INTERVAL);
      };

      const stopAutoRotate = () => {
        if (autoRotateTimer) {
          clearInterval(autoRotateTimer);
          autoRotateTimer = null;
        }
      };

      const activateThisCard = () => {
        if (prefersReducedMotion) return;
        if (window._activeProductCardRotate?.card === card) return;
        if (window._activeProductCardRotate) {
          window._activeProductCardRotate.stop();
        }
        window._activeProductCardRotate = { card, start: startAutoRotate, stop: stopAutoRotate };
        // hover/active した瞬間に即切り替え、その後は間隔でカルーセル
        switchImage((currentIndex + 1) % productImages.length);
        startAutoRotate();
      };

      const deactivateThisCard = () => {
        if (window._activeProductCardRotate?.card === card) {
          stopAutoRotate();
          window._activeProductCardRotate = null;
        }
      };

      // カラバリサムネイルの hover/click でカルーセル停止＆その画像に切り替え
      const variantItemElements = card.querySelectorAll(
        ".product-card-default-item[data-variant-image-index]",
      );
      variantItemElements.forEach((item) => {
        const targetIndex = parseInt(item.dataset.variantImageIndex, 10);
        if (isNaN(targetIndex)) return;

        const showVariantImageOnHover = (e) => {
          e.preventDefault();
          e.stopPropagation();
          stopAutoRotate();
          if (window._activeProductCardRotate?.card === card) {
            window._activeProductCardRotate = null;
          }
          switchImage(targetIndex);
        };

        if (isDesktop) {
          // PC: hover で画像切り替え、click はリンクのデフォルト（詳細ページ遷移）を許可
          item.addEventListener("mouseenter", showVariantImageOnHover);
        } else {
          // スマホ: click で画像切り替え（hover がないため）
          item.addEventListener("click", showVariantImageOnHover);
        }
      });

      if (!prefersReducedMotion) {
        if (isDesktop) {
          hoverTarget.addEventListener("mouseenter", activateThisCard);
          hoverTarget.addEventListener("mouseleave", deactivateThisCard);
          imageContainer.addEventListener("mouseenter", () => {
            if (!autoRotateTimer) {
              activateThisCard();
            }
          });
        } else {
          // スマホ: touchstart で検知（Safari は click/hover が不安定）
          imageContainer.addEventListener("touchstart", () => {
            activateThisCard();
          }, { passive: true });
        }
      }

      if (!isDesktop) {
        // モバイル: スワイプで切り替え
        let touchState = {
          startX: 0,
          endX: 0,
          startY: 0,
          endY: 0,
          isDragging: false,
          hasMoved: false,
        };

        const handleTouchStart = (e) => {
          touchState.startX = e.touches[0].clientX;
          touchState.startY = e.touches[0].clientY;
          touchState.isDragging = true;
          touchState.hasMoved = false;
        };

        const handleTouchMove = (e) => {
          if (!touchState.isDragging) return;

          touchState.endX = e.touches[0].clientX;
          touchState.endY = e.touches[0].clientY;

          const diffX = Math.abs(touchState.endX - touchState.startX);
          const diffY = Math.abs(touchState.endY - touchState.startY);

          if (diffX > SWIPE_MOVE_THRESHOLD || diffY > SWIPE_MOVE_THRESHOLD) {
            touchState.hasMoved = true;
          }
        };

        const handleTouchEnd = (e) => {
          if (!touchState.isDragging) return;

          touchState.isDragging = false;

          const diff = touchState.startX - touchState.endX;
          const diffY = Math.abs(touchState.endY - touchState.startY);
          const diffX = Math.abs(diff);

          if (touchState.hasMoved && diffX > SWIPE_THRESHOLD && diffX > diffY) {
            e.preventDefault();
            activateThisCard();

            if (diff > 0) {
              switchImage((currentIndex + 1) % productImages.length);
            } else {
              switchImage(
                currentIndex === 0
                  ? productImages.length - 1
                  : currentIndex - 1,
              );
            }
          } else if (!touchState.hasMoved) {
            activateThisCard();
          }

          touchState = {
            startX: 0,
            endX: 0,
            startY: 0,
            endY: 0,
            isDragging: false,
            hasMoved: false,
          };
        };

        imageContainer.addEventListener("touchstart", handleTouchStart, {
          passive: true,
        });
        imageContainer.addEventListener("touchmove", handleTouchMove, {
          passive: true,
        });
        imageContainer.addEventListener("touchend", handleTouchEnd);
      }
    });
  };

  /**
   * 商品カード画像の状態をリセット
   */
  const resetProductCardImages = () => {
    const productCards = document.querySelectorAll(SELECTORS.productCard);
    productCards.forEach((card) => {
      const mainImage = card.querySelector(".product-card-default-thum-image");
      if (mainImage) {
        const computedStyle = getComputedStyle(mainImage);
        if (mainImage.style.opacity === "0" || computedStyle.opacity === "0") {
          mainImage.style.opacity = "1";
          mainImage.style.transition = "";
        }
      }
    });
  };

  window.themeV2.resetProductCardImages = resetProductCardImages;
  window.themeV2.setSwipeProductCardImage = setSwipeProductCardImage;
  // スマホ: カード外タップでカルーセル停止
  const stopOnOutsideTap = (e) => {
    if (!window._activeProductCardRotate?.card) return;
    if (window._activeProductCardRotate.card.contains(e.target)) return;
    window._activeProductCardRotate.stop();
    window._activeProductCardRotate = null;
  };
  document.addEventListener("touchstart", stopOnOutsideTap, { passive: true });
  document.addEventListener("click", stopOnOutsideTap, true);

  // 初期化
  document.addEventListener("DOMContentLoaded", () => {
    initializeSearchLogic();
    initializeHeaderBehavior();
    initializeMileGraph();
    categoryExpand(".v2-header-menu");
    addAppifyClass();
    resetProductCardImages();
    setSwipeProductCardImage();
  });

  // ブラウザバック/フォワード時の処理（bfcache対応）
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      resetProductCardImages();
      const productCards = document.querySelectorAll(SELECTORS.productCard);
      productCards.forEach((card) => {
        delete card.dataset.sliderInitialized;
      });
      setSwipeProductCardImage();
    }
  });

  // ウィンドウリサイズ時の処理（throttle適用）
  let resizeTimer;
  window.addEventListener(
    "resize",
    () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        categoryExpand(".v2-header-menu");
      }, 100);
    },
    { passive: true },
  );
})();
